<script lang="ts" setup>
import HotMatchCard from '~common/hot-match/hot-match-card.vue'
import { useHotmatches } from '~/composables/home/use-hotmatches'
import { useSwiper } from '~/composables/common/use-swiper'

const { hotmatches, isLoadingHotmatch } = useHotmatches()
const { modules } = useSwiper()
</script>
<template>
  <div v-if="hotmatches?.length && !isLoadingHotmatch" class="sport-hotmatch">
    <Swiper
      v-if="hotmatches?.length"
      :modules="modules"
      :slidesPerView="1"
      :spaceBetween="24"
      loop
      :autoplay="{ delay: 10000 }"
      :pagination="{ clickable: true }"
    >
      <SwiperSlide v-for="(hotmatch, index) in hotmatches" :key="`hot-match+${index}`">
        <HotMatchCard :hotmatch="hotmatch" />
      </SwiperSlide>
    </Swiper>
  </div>
  <!-- Empty data section -->
  <div v-if="!hotmatches?.length && !isLoadingHotmatch" class="sport-hotmatch-empty-section">
    <img src="/assets/images/sports/mobile/empty-hot-match.png" alt="empty hotmatch icon" />
    <p>Lịch thi đấu đang được cập nhật</p>
  </div>
</template>

<style lang="scss" scoped>
@import '~scssAsset/mobile/sports/v2/hot-match.scss';
</style>
